import React from "react";
import * as Styles from "./styles/WinterWheelToggle";
import { BnbLabel } from "../../../utils/labels";
import IconSnowFlake from "../../../svg/lexus/snowflake.svg";
import IconSunStroke from "../../../svg/lexus/sun-stroke.svg";
import { useTheme } from "../../../../../../common-deprecated/themes/common";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../redux/store";
import { showWinterWheel as showWinterWheelAction } from "../../../../../../common-deprecated/redux/actions/UtilActions";
import { trackWinterWheelsToggle } from "../../../utils/tracking";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const WinterWheelToggle = (): JSX.Element => {
    const { color } = useTheme();
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const showWinterWheel = useBnbSelector((state) => state.utils.showWinterWheel);

    const toggleWinterWheel = (): void => {
        const newValue = !showWinterWheel;
        trackWinterWheelsToggle(newValue);
        dispatch(showWinterWheelAction(newValue));
    };

    return (
        <Styles.WinterToggle>
            <label>
                <Styles.Label>
                    <BnbLabel label="winterWheelsToggleButtonWinterSet" />
                </Styles.Label>
                <Styles.ToggleStates isActive={showWinterWheel} onClick={toggleWinterWheel}>
                    <IconSnowFlake fill={color.lightest} width="16" height="16" viewBox="0 0 20 20" />
                    <IconSunStroke fill={color.lightest} width="16" height="16" viewBox="0 0 20 20" />
                </Styles.ToggleStates>
            </label>
        </Styles.WinterToggle>
    );
};

export default WinterWheelToggle;
